(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.componentHero = {
    updateSlideAria: function (swiperInstance) {
      $(swiperInstance.slides).attr('aria-hidden', 'true').find('*').attr('tabindex', '-1');
      var index = (swiperInstance.params.slidesPerColumn * swiperInstance.realIndex);
      var itemsPerSlide = (swiperInstance.params.slidesPerColumn * swiperInstance.params.slidesPerView);
      $(swiperInstance.slides).slice(index, index + itemsPerSlide).removeAttr('aria-hidden').find('*').removeAttr('tabindex');
    },
    attach: function (context, settings) {
      $('.component-hero:not(.component-hero--js-initialized)', context).each(function (index) {
        var $component = $(this);

        if ($component.find('video').length > 0) {
          const $video = $component.find('video');
          $video.attr('playsinline', 'playsinline');
        }

        if ($component.find('article').length > 1) {
          // Track that this component has been initialized.
          $component.addClass('component-hero--js-initialized');
          var $heroWrapper = $component.find('.component-hero__inner');
          var $hero = $component.find('.component-hero__content');
          var $heroItems = $component.find('.component-hero__content article');
          // Add swiper classes and elements.
          $heroWrapper.addClass('swiper');
          $heroWrapper.addClass('swiper-container');
          $heroItems.addClass('swiper-slide');
          $hero.addClass('swiper-wrapper');
          var $cards = $('.component-hero-slide__card');
          $($cards).each(function (index) {
            $(this).attr('data-card-index', index);
          });

          $heroItems.each(function (index) {
            const isMiddleAligned = $(this).hasClass('content-vertical-alignment--middle');
            const isBottomAligned = $(this).hasClass('content-vertical-alignment--bottom');
            if (isMiddleAligned || isBottomAligned) {
              const $targetCard = $(`.component-hero-slide__card[data-card-index=${index}]`);
              const targetClass = isMiddleAligned ? 'content-vertical-alignment--middle' : 'content-vertical-alignment--bottom';
              $targetCard.addClass(targetClass);
            }
          });
        }
        // Initialize swiper.
        if ($component.find('article').length > 1) {
          // eslint-disable-next-line
          var mySwiper = new Swiper('.component-hero__inner', {
            autoplay: {
              delay: 7000
            },
            on: {
              init: function () {
                $('.component-hero-slide__card[data-card-index="0"]').addClass('active');
                // Use a timeout on init to make sure to catch contextual links.
                setTimeout(Drupal.behaviors.componentHero.updateSlideAria($(this)[0]), 500);
              },
              resize: function () {
                Drupal.behaviors.componentHero.updateSlideAria($(this)[0]);
                if (typeof Drupal.blazy !== 'undefined') {
                  Drupal.blazy.init.revalidate();
                }
              },
              slideChangeTransitionEnd: function () {
                Drupal.behaviors.componentHero.updateSlideAria($(this)[0]);
                if (typeof Drupal.blazy !== 'undefined') {
                  Drupal.blazy.init.revalidate();
                }
              },
              slideChange: function () {
                $('.component-hero-slide__card').removeClass('active');
                if (this.realIndex === 0) {
                  $('.component-hero-slide__card[data-card-index="1"]').appendTo('.component-hero-slide__cards-container');
                  $('.component-hero-slide__card[data-card-index="2"]').appendTo('.component-hero-slide__cards-container');
                }
                else if (this.realIndex === 1) {
                  $('.component-hero-slide__card[data-card-index="2"]').appendTo('.component-hero-slide__cards-container');
                  $('.component-hero-slide__card[data-card-index="0"]').appendTo('.component-hero-slide__cards-container');
                }
                else if (this.realIndex === 2) {
                  $('.component-hero-slide__card[data-card-index="0"]').appendTo('.component-hero-slide__cards-container');
                  $('.component-hero-slide__card[data-card-index="1"]').appendTo('.component-hero-slide__cards-container');
                }
              }
            },
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 40,
            touchEventsTarget: 'container',
            centeredSlides: true,
            centerInsufficientSlides: true,
            loop: true,
            effect: 'creative',
            creativeEffect: {
              prev: {
                translate: ['-20%', 0, -1]
              },
              next: {
                translate: ['100%', 0, 0]
              }
            }
          });


          $('.component-hero-slide__card').on('click', function () {
            var $slideIndex = $(this).attr('data-card-index');
            var $firstSlide = $('.component-hero-slide__card[data-card-index="0"]').attr('data-card-index');
            var $secondSlide = $('.component-hero-slide__card[data-card-index="1"]').attr('data-card-index');
            var $thirdSlide = $('.component-hero-slide__card[data-card-index="2"]').attr('data-card-index');
            $(this).prependTo('.component-hero-slide__cards-container');
            mySwiper.slideTo(parseInt($slideIndex) + 1);
            if (!$(this).hasClass('active')) {
              if ($(this).attr('data-card-index') === $firstSlide) {
                $('.component-hero-slide__card[data-card-index="1"]').appendTo('.component-hero-slide__cards-container');
                $('.component-hero-slide__card[data-card-index="2"]').appendTo('.component-hero-slide__cards-container');
              }
              else if ($(this).attr('data-card-index') === $secondSlide) {
                $('.component-hero-slide__card[data-card-index="2"]').appendTo('.component-hero-slide__cards-container');
                $('.component-hero-slide__card[data-card-index="0"]').appendTo('.component-hero-slide__cards-container');
              }
              else if ($(this).attr('data-card-index') === $thirdSlide) {
                $('.component-hero-slide__card[data-card-index="0"]').appendTo('.component-hero-slide__cards-container');
                $('.component-hero-slide__card[data-card-index="1"]').appendTo('.component-hero-slide__cards-container');
              }
            }
            $('.component-hero-slide__card').removeClass('active');
            $(this).addClass('active');



            // $(this).prependTo('.component-hero-slide__cards-container');
          });
        }

      });
    }
  };

})(jQuery, Drupal);
